module.exports = __webpack_public_path__ + "media/images/emblems/Grubar-32aa4c3071b3f294f8dabec21c8d0a06.png";